import './App.css';
import './MediaQueries.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ScrollToTop from './Components/ScrollToTop';
import Home from './Pages/Home';
import About from './Pages/About';
import Services from './Pages/Services';
import ServiceDetail from './Pages/ServiceDetail';
import Industries from './Pages/Industries';
import IndustryDetail from './Pages/IndustryDetail';
import Enquiry from './Pages/Enquiry';
import Contact from './Pages/Contact';
import Header from './Components/Header';
import Footer from './Components/Footer';
import TermsConditions from './Pages/TermsConditions';
import PrivacyPolicy from './Pages/PrivacyPolicy';
import NotFound from './Pages/NotFound';


function App() {
  return (
   <BrowserRouter>
     <ScrollToTop />
     <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about-us" element={<About />} />
        <Route path="/services" element={<Services />} />
        <Route path="/services/:slug" element={<ServiceDetail />} />
        <Route path="/industries" element={<Industries />} />
        <Route path="/industries/:slug" element={<IndustryDetail />} />
        <Route path="/enquiry" element={<Enquiry />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/terms-and-conditions" element={<TermsConditions />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
         <Route path="/*" element={<NotFound />} />
      </Routes>
      <Footer />
      </BrowserRouter>
  );
}

export default App;
